<template>
  <div class="container">
    <div class="m-block m-block--text" :class="{ 'm-block--dark': background }">
      <div class="m-block__content" />
      <aside class="m-block__aside">
        <h4 class="m-block__title f-title-5">{{ title }}</h4>
        <div class="f-rte f-rte--block">
          <slot />
        </div>
      </aside>
    </div>
  </div>
</template>

<script>
/** Left aligned block with both title and text in the aside */
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    background: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.f-rte--block {
  margin-top: 20px;
}
@media screen and (min-width: 730px) and (max-width: 959px) {
  .m-block--text .m-block__aside,
  .m-block--text .m-block__content {
    width: calc((100vw - 276px) / 8 * 4 + 84px) !important;
  }
  /* Style fixes for when this component appears inside a code block */
  .m-block {
    justify-content: flex-end;
  }
}

@media screen and (min-width: 960px) and (max-width: 1279px) {
  .m-block--text .m-block__aside,
  .m-block--text .m-block__content {
    width: calc((100vw - 576px) / 16 * 8 + 224px) !important;
  }
}

@media screen and (min-width: 1280px) and (max-width: 1479px) {
  .m-block--text .m-block__aside,
  .m-block--text .m-block__content {
    width: calc((100vw - 576px) / 16 * 8 + 224px) !important;
  }
}

@media screen and (min-width: 1480px) {
  .m-block--text .m-block__aside,
  .m-block--text .m-block__content {
    width: 676px !important;
  }
}
</style>